(() => {
  const THRESHOLD = 39; // dollars
  const BANNER_ID = "fld-free-shipping-banner";

  const TEXT_UNLOCKED = `
    <div style="font-size:14px; margin-bottom:6px;">
      🚚 FREE SHIPPING UNLOCKED
    </div>
    <div style="font-size:13px; font-weight:600; margin-bottom:6px;">
      LIMITED DROP — No restocks once sold out
    </div>
    <div style="font-size:12px; opacity:0.85; text-transform:none; font-weight:500; line-height:1.5;">
      ✔ Ships from California<br>
      ✔ Secure checkout
    </div>
  `;

  const TEXT_REMAINING = (remaining) => `
    <div style="font-size:14px; margin-bottom:6px;">
      You're $${remaining.toFixed(2)} away from FREE U.S. SHIPPING 🏁
    </div>
    <div style="font-size:12px; opacity:0.85; text-transform:none; font-weight:500; line-height:1.5;">
      Limited drop — no restocks once sold out
    </div>
  `;

  const moneyFromCents = (cents) => Number(cents || 0) / 100;

  async function fetchCartTotal() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await res.json();
    return moneyFromCents(cart.total_price);
  }

  function getDrawerBody() {
    return document.querySelector("#MinimogCartDrawerBody");
  }

  function getInsertTarget(drawerBody) {
    return (
      drawerBody.querySelector(".m-cart-drawer__items") ||
      drawerBody.querySelector("form") ||
      drawerBody
    );
  }

  function ensureBanner(target) {
    if (!target) return null;

    let banner = document.getElementById(BANNER_ID);

    if (banner && !document.body.contains(banner)) banner = null;

    if (!banner) {
      banner = document.createElement("div");
      banner.id = BANNER_ID;
      banner.style.cssText = `
        margin: 14px 16px;
        padding: 14px 16px;
        border-radius: 12px;
        border: 1px solid rgba(255,255,255,0.25);
        background: rgba(0,0,0,0.28);
        color: #fff;
        text-align: center;
        font-weight: 800;
        text-transform: uppercase;
        line-height: 1.2;
        user-select: none;
      `;
    }

    if (target.firstChild !== banner) {
      target.prepend(banner);
    }

    return banner;
  }

  function setBannerText(banner, total) {
    if (!banner) return;
    if (total >= THRESHOLD) banner.innerHTML = TEXT_UNLOCKED;
    else banner.innerHTML = TEXT_REMAINING(THRESHOLD - total);
  }

  let running = false;

  async function tick() {
    if (running) return;
    running = true;

    try {
      const drawerBody = getDrawerBody();
      if (!drawerBody) return;

      const target = getInsertTarget(drawerBody);
      const banner = ensureBanner(target);

      const total = await fetchCartTotal();
      setBannerText(banner, total);
    } catch (e) {
      console.log("FLD free shipping error:", e);
    } finally {
      running = false;
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      tick();
      setInterval(tick, 700);
    }, 300);
  });
})();